<template>
  <div>
    <div class="d-flex">
      <v-combobox
        v-model="searchChips"
        outlined
        clearable
        multiple
        chips
        small-chips
        class="mr-2 blue-chips search-box"
        hide-details
        :items="[]"
        append-icon=""
        hide-no-data
        :open-on-click="false"
        :menu-props="{ closeOnContentClick: true, openOnClick: false }"
        placeholder="Type term and press Enter to add filter"
        prepend-inner-icon="mdi-magnify"
        @input="onSearchInput"
        deletable-chips
        color="primary"
        chip-color="primary"
        text-color="white"
      ></v-combobox>
      <v-btn
  small
  class="ml-2"
  :color="filterEnabled ? 'success' : 'grey'"
  @click="toggleFilter"
>
  <v-icon left>
    {{ filterEnabled ? 'mdi-filter-check' : 'mdi-filter-off' }}
  </v-icon>

  {{ filterEnabled ? 'Filter ON' : 'Filter OFF' }}
</v-btn>
      <v-spacer></v-spacer>
      <v-btn color="primary" small outlined @click="add()">
        <v-icon left>mdi-plus</v-icon>
        ADD OPTION
      </v-btn>
    </div>
    <v-card outlined class="mt-4">
      <v-data-table
        class="templates-table"
        :headers="headers"
        :items-per-page="-1"
        :items="filteredList"
        item-key="id"
        hide-default-footer
      >
        <template v-slot:body="{ items }">
          <tbody>
            <tr v-for="item in items" :key="item.id" :class="trackChanges ? rowClass(item) : ''">
              <td class="pa-2 wrap-text" @click="startEdit(item.id, 'name')">
                <v-textarea
                  v-if="isEditing(item.id, 'name')"
                  ref="cellInput"
                  v-model="item.name"
                  hide-details=""
                  :rules="rules"
                  outlined
                  dense
                  auto-grow
                  rows="1"
                  @input="onInput"
                  @blur="stopEdit"
                />
                <div v-else class="plain-cell">{{ item.name }}</div>
              </td>
              <td class="pa-2 wrap-text" @click="startEdit(item.id, 'value')">
                <v-textarea
                  v-if="isEditing(item.id, 'value')"
                  ref="cellInput"
                  v-model="item.value"
                  outlined
                  hide-details=""
                  :rules="rules"
                  dense
                  auto-grow
                  rows="1"
                  @input="onInput"
                  @blur="stopEdit"
                />
                <div v-else class="plain-cell">{{ item.value }}</div>
              </td>
                      <td class="pa-2 text-center">
                <v-btn v-if="isAdmin && trackChanges && item.pendingDelete" color="grey" icon @click="remove(item.id)">
                  <v-icon>mdi-undo</v-icon>
                </v-btn>
                <remove-icon-button v-else-if="isAdmin" @click="remove(item.id)"></remove-icon-button>
              </td>
            </tr>
          </tbody>
        </template>
      </v-data-table>
    </v-card>
    <div class="d-flex mt-3">
      <v-spacer></v-spacer>
      <v-btn color="primary" small outlined @click="add()">
        <v-icon left>mdi-plus</v-icon>
        ADD OPTION
      </v-btn>
    </div>
  </div>
</template>

<script>
import { FIELD } from "../../assets/js/rules";
import RemoveIconButton from "../buttons/RemoveIconButton.vue";
export default {
  components: { RemoveIconButton },
  props: {
    value: {
      type: Array,
      default: () => []
    },
    beforeRemove: {
      type: Function,
      default: null
    },
    // Opt-in only — Key Category is the only field that needs the delayed
    // red/yellow marking, persisted id, and live master-merge. Every other
    // use of this component (generic service/global fields) must behave
    // exactly as before: immediate delete on click, no id, no merging.
    trackChanges: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      list: [],
      search: '',
      searchChips: [],
      filterEnabled: true, 
      frozenList: [],
      selected: false,
      rules: FIELD,
      types: ["Text", "Number", "Percentage"],
      editingCell: null
    };
  },
  computed: {
    filteredList() {
      // Filter OFF freezes the currently-matched subset so editing a row
      // (e.g. removing the searched term from its value) doesn't make it
      // vanish out from under the user mid-edit — it must NOT be re-filtered
      // live while off.
      if (!this.filterEnabled) {
        return this.frozenList;
      }
      const terms = this.normalizeSearchChips(this.searchChips).map(t => t.toLowerCase().replace(/\s+/g, ' ').trim());
      if (!terms.length) return this.list;
      return this.list.filter(it => {
        if (it.isNew) {
          return true;
        }
        const hay = [it.name, it.value].map(x => (x || "").toString().toLowerCase().replace(/\s+/g, ' ').trim()).join(' ');
        return terms.every(term => hay.includes(term));
      });
    },
    headers() {
      let list = {
        name: "Name",
        value: "Value",
        action: "Action"
      };
      let items = [];
      Object.keys(list).forEach(key => {
        let doc = {
          text: list[key].toUpperCase(),
          align: "start",
          divider: true,
          class: "font-weight-bold",
          sortable: false,
          value: key
        };
        if (key === "action") {
          doc.width = "100px";
          doc.divider = false;
          doc.align = "center";
        }
        if (key == "type") doc.width = "150px";
        items.push(doc);
      });
      return items;
    }
  },
  mounted() {
    this.add();
    this.init();
  },
  watch: {
    value(newVal) {
      // Re-init when parent pushes fresh Firestore options (no originalValue means it's a new load,
      // not a value emitted by onInput). This keeps originalValue current across multiple saves
      // without closing/remounting the dialog.
      if (Array.isArray(newVal) && newVal.every(opt => opt.originalValue === undefined)) {
        this.init();
      }
    }
    ,
    searchChips(val) {
      if (Array.isArray(val)) {
        const unique = this.normalizeSearchChips(val);
        if (unique.length !== val.length || unique.some((v, i) => v !== val[i])) {
          this.searchChips = unique;
        }
      } else {
        this.searchChips = [];
      }
    }
  },
  methods: {
    refresh() {
    this.init();
  },
    getRows() {
      return this.list.map(r => ({ ...r }));
    },
    // Live-reconciles this list against the latest master data (called by the
    // parent whenever another user's save/sync completes). A row the current
    // user hasn't touched is silently synced to (or removed with) whatever
    // master now says. A row marked red (pendingDelete) or yellow (edited) is
    // left exactly as the user left it — the parent's submit-time conflict
    // check is what surfaces a clash on those, not this live merge.
    // renameMap/removals are keyed by id when the row has one, falling back
    // to originalValue for legacy rows saved before ids existed — must match
    // the same key scheme the caller (Create.vue) used to build them.
    mergeMaster(freshOptions, renameMap = {}, removals = new Set()) {
      const vm = this;
      if (!vm.trackChanges || !Array.isArray(freshOptions)) return;
      const seenIds = new Set();
      const seenValues = new Set();
      const nextList = [];

      const findFresh = (item) => item.id
        ? freshOptions.find((f) => f.id === item.id)
        : freshOptions.find((f) => f.value === item.originalValue);

      const markSeen = (entry) => {
        if (entry && entry.id) seenIds.add(entry.id);
        if (entry && entry.value) seenValues.add(entry.value);
      };

      vm.list.forEach((item) => {
        const key = item.id || item.originalValue;

        if (item.isNew) {
          // Never-saved local addition — always kept, master has no say in it.
          nextList.push(item);
          return;
        }

        const touched = item.pendingDelete ||
          item.name !== item.originalName || item.value !== item.originalValue;
        if (touched) {
          nextList.push(item);
          // Don't overwrite what the user is editing, but if master now
          // calls this same row something else (renamed elsewhere), mark
          // that target as accounted for so it isn't also added below as a
          // separate "new" row.
          const renamed = renameMap[key];
          if (renamed) markSeen(renamed);
          else { seenValues.add(item.originalValue); if (item.id) seenIds.add(item.id); }
          return;
        }

        // Untouched — sync to whatever master/rename-map currently says.
        const fresh = findFresh(item);
        if (fresh) {
          item.id = fresh.id || item.id;
          item.name = fresh.name;
          item.value = fresh.value;
          item.originalName = fresh.name;
          item.originalValue = fresh.value;
          nextList.push(item);
          markSeen(fresh);
          return;
        }

        const renamed = renameMap[key];
        if (renamed) {
          item.name = renamed.name;
          item.value = renamed.value;
          item.originalName = renamed.name;
          item.originalValue = renamed.value;
          nextList.push(item);
          markSeen(renamed);
          return;
        }

        if (removals.has(key)) {
          // Deleted by someone else, untouched here — drop it silently.
          return;
        }

        // No information either way — keep defensively rather than lose data.
        nextList.push(item);
        seenValues.add(item.originalValue);
        if (item.id) seenIds.add(item.id);
      });

      // Anything added by someone else that has no local row yet.
      freshOptions.forEach((f) => {
        if (f.id ? seenIds.has(f.id) : seenValues.has(f.value)) return;
        nextList.push(this.createItem({
          id: f.id,
          name: f.name,
          value: f.value,
          originalValue: f.value,
          originalName: f.name,
        }));
      });

      vm.list = nextList;
      if (!vm.filterEnabled) {
        // Reconcile only the rows already in the frozen subset (renamed/
        // removed there get updated/dropped) — don't repopulate it with
        // everything, that would undo the freeze and show the full list.
        const frozenIds = new Set(vm.frozenList.map((r) => r.id));
        vm.frozenList = nextList.filter((r) => frozenIds.has(r.id));
      }
      vm.onInput();
    },
    toggleFilter() {
    if (this.filterEnabled) {
      // Freeze current filtered result
      this.frozenList = [...this.filteredList];
      this.filterEnabled = false;
    } else {
      // Enable live filtering again
      this.filterEnabled = true;
    }
  },
    normalizeSearchChips(arr) {
      if (!Array.isArray(arr)) return [];
      return Array.from(new Set(arr.filter(i => i !== undefined && i !== null).map(i => i.toString().trim()).filter(Boolean)));
    },
    generateItemId() {
      return `${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 10)}`;
    },
    createItem({ id, name = "", value = "", originalValue, originalName, isNew=false } = {}) {
      return {
        id: id || this.generateItemId(),
        name,
        value,
        originalValue: originalValue !== undefined ? originalValue : value,
        originalName: originalName !== undefined ? originalName : name,
        selected: this.selected,
        isNew,
        pendingDelete: false,
      };
    },
    rowClass(item) {
      if (item.pendingDelete) return "row-pending-delete";
      const isEdited = !item.isNew && (item.name !== item.originalName || item.value !== item.originalValue);
      if (isEdited) return "row-pending-edit";
      return "";
    },
    onSearchInput() {
      // noop for now — keeps v-model updates predictable and is a good
      // place to add debounce or analytics later.
    },
    isEditing(id, field) {
      return this.editingCell === `${id}:${field}`;
    },
    startEdit(id, field) {
      this.editingCell = `${id}:${field}`;
      this.$nextTick(() => {
        const ref = this.$refs.cellInput;
        const input = Array.isArray(ref) ? ref[0] : ref;
        if (input && input.focus) input.focus();
      });
    },
    stopEdit() {
       const cell = this.editingCell;

  if (cell) {
    const id = cell.split(":")[0];

    const row = this.list.find(x => x.id === id);

    if (row) {
      const hasData =
        row.name.trim() !== "" &&
        row.value.trim() !== "";

        

      if (hasData) {
        row.isNew = false;
      }
    }
  }

  this.editingCell = null;
    },

    fieldType({ type }) {
      if (!type) return "";
      return type == "Text" ? "text" : "number";
    },
    onInput() {
      let doc = [];
      this.list.forEach(({ id, name, value, originalValue, originalName, pendingDelete, isNew }) => {
        if (!this.trackChanges) {
          // Original behavior for every non-Key-Category field: plain
          // name/value/originalValue/originalName, no id, no isNew.
          doc.push({
            name,
            value,
            originalValue: originalValue !== undefined ? originalValue : value,
            originalName: originalName !== undefined ? originalName : name,
          });
          return;
        }
        // Rows marked for delete stay visible (red) until submit, but must
        // not appear in the emitted doc — the parent's diff treats "missing
        // from newOptions" as the delete signal.
        if (pendingDelete) return;
        doc.push({
          id,
          name,
          value,
          originalValue: originalValue !== undefined ? originalValue : value,
          originalName: originalName !== undefined ? originalName : name,
          isNew: !!isNew,
        });
      });
      this.$emit("input", doc);
    },
    async remove(iOrId) {
      const vm = this;
      let idx = typeof iOrId === "number" ? iOrId : vm.list.findIndex(x => x.id === iOrId);
      if (idx === -1) return;
      const item = vm.list[idx];

      if (!vm.trackChanges) {
        // Original behavior: confirm (if a beforeRemove hook is given) then
        // delete immediately — no red marking, no undo.
        if (vm.beforeRemove) {
          const confirmed = await vm.beforeRemove(item);
          if (!confirmed) return;
        }
        vm.list.splice(idx, 1);
        if (!vm.filterEnabled) {
          const frozenIndex = vm.frozenList.findIndex((x) => x.id === iOrId);
          if (frozenIndex !== -1) vm.frozenList.splice(frozenIndex, 1);
        }
        vm.onInput();
        return;
      }

      // Already marked for delete — clicking again undoes it.
      if (item.pendingDelete) {
        item.pendingDelete = false;
        this.onInput();
        return;
      }

      // A row added and never saved has nothing to "pend" — remove outright.
      if (item.isNew) {
        vm.list.splice(idx, 1);
        if (!this.filterEnabled) {
          const frozenIndex = this.frozenList.findIndex(x => x.id === iOrId);
          if (frozenIndex !== -1) this.frozenList.splice(frozenIndex, 1);
        }
        this.onInput();
        return;
      }

      if (vm.beforeRemove) {
        const confirmed = await vm.beforeRemove(item);
        if (!confirmed) return;
      }
      item.pendingDelete = true;
      this.onInput();
    },
    add() {
  const item = this.createItem({
    isNew: true
  });

  this.list.push(item);
   if (!this.filterEnabled) {
    this.frozenList.push(item);
  }
  this.onInput();

  this.$nextTick(() => {
    this.startEdit(item.id, "name");
  });
},
    init() {
      const vm = this;
      let options = vm.value;
      let list = [];
      if (options instanceof Object) {
        options.forEach(item => {
          let { id, name, value } = item;
          list.push(this.createItem({
            id: vm.trackChanges ? id : undefined,
            name,
            value,
            originalValue: value,
            originalName: name
          }));
        });
      }
      vm.list = list;
      this.onInput();
    }
  }
};
</script>

<style>
.row-pending-delete {
  background-color: rgba(244, 67, 54, 0.12);
}
.row-pending-edit {
  background-color: rgba(255, 235, 59, 0.18);
}
.templates-table table {
  table-layout: fixed;
  width: 100%;
}
.wrap-text {
  white-space: normal !important;
  max-width: 240px;
}
.wrap-text .v-input__slot,
.wrap-text textarea {
  white-space: normal !important;
  overflow-wrap: anywhere !important;
  word-break: break-word !important;
}
.wrap-text .v-textarea__textarea {
  min-height: 48px;
}
.templates-table .wrap-text textarea,
.templates-table .plain-cell {
  font-size: 16px !important;
  line-height: 1.5 !important;
}
.plain-cell {
  min-height: 24px;
  padding: 12px;
  white-space: pre-wrap;
  overflow-wrap: anywhere;
  word-break: break-word;
  cursor: text;
  border: 1px solid rgba(0, 0, 0, 0.38);
  border-radius: 4px;
  line-height: 1.4;
}
.search-box .v-input__slot {
  min-height: 48px;
  padding-top: 4px;
  padding-bottom: 4px;
}
.search-box.v-text-field--outlined fieldset {
  border-width: 2px;
}
.blue-chips .v-chip {
  background-color: #0400ff !important;
  color: #fff !important;
}
.blue-chips .v-chip__close {
  color: rgba(255,255,255,0.8) !important;
}
</style>
